export default function SwapIcon() {
	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
		<svg
			width="29"
			height="29"
			viewBox="0 0 29 29"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.90827 12.4347H21.6358C22.2026 12.4347 22.6663 11.971 22.6663 11.4042C22.6663 10.8374 22.2026 10.3736 21.6358 10.3736H8.90827C8.71933 10.3736 8.55787 10.298 8.44451 10.1572C8.30023 9.97512 8.26588 9.72091 8.34145 9.39456L8.36207 9.29838L12.0549 5.60551C12.2507 5.41314 12.3572 5.15206 12.3572 4.87725C12.3572 4.60243 12.2507 4.34135 12.0549 4.14898C11.8557 3.94974 11.5912 3.84668 11.3267 3.84668C11.0622 3.84668 10.7976 3.9463 10.5984 4.14898L6.97423 7.77314C6.46582 8.28155 6.17383 8.98577 6.17383 9.70373C6.17383 11.2084 7.4002 12.4347 8.90483 12.4347H8.90827Z"
				fill="white"
			/>
			<path
				d="M7.2083 18.6178H19.9358C20.1247 18.6178 20.2862 18.6933 20.3996 18.8342C20.5438 19.0163 20.5782 19.2705 20.5026 19.5968L20.482 19.693L16.7891 23.3859C16.5933 23.5782 16.4868 23.8393 16.4868 24.1141C16.4868 24.3889 16.5933 24.65 16.7891 24.8424C17.1773 25.2306 17.8575 25.2306 18.2457 24.8424L21.8698 21.2182C22.3782 20.7098 22.6702 20.0056 22.6702 19.2876C22.6702 17.783 21.4439 16.5566 19.9392 16.5566H7.2083C6.64149 16.5566 6.17773 17.0204 6.17773 17.5872C6.17773 18.154 6.64149 18.6178 7.2083 18.6178Z"
				fill="white"
			/>
		</svg>
	);
}
